import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const PhoneCross = () => (
  <ImageIcon src={Images.PhoneCross} alt="Phone Cross" />
);

export default PhoneCross;
